import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import FB from "../assets/icons/fb.png";
import Insta from "../assets/icons/insta.png";
import Twitter from "../assets/icons/twitter.png";
import YouTube from "../assets/icons/utube.png";
import client1 from "../assets/images/client1.jpg";
import client2 from "../assets/images/client2.jpg";
import client3 from "../assets/images/client3.jpg";
import client4 from "../assets/images/client4.jpg";
import about from "../assets/images/about.png";
import apple from "../assets/images/apple.png";
import doctors from "../assets/images/doctors.png";
import google from "../assets/images/google.png";
import Team1 from "../assets/images/team1.jpg";
import Team2 from "../assets/images/team2.png";
import icon1 from "../assets/icons/icon1.png";
import icon2 from "../assets/icons/icon2.png";
import icon3 from "../assets/icons/icon3.png";
import icon4 from "../assets/icons/icon4.png";
import icon5 from "../assets/icons/icon5.png";
import icon6 from "../assets/icons/icon6.png";
import icon7 from "../assets/icons/icon7.png";
import Quotes from "../assets/icons/quotes.svg";
import Works1 from "../assets/icons/works1.png";
import Works2 from "../assets/icons/works2.png";
import Works3 from "../assets/icons/works3.png";
import Works4 from "../assets/icons/works4.png";
import Counter from "../components/Counter";
import AppointmentForm from "../components/AppointmentForm";
import Footer from "../components/Footer";
import FAQ from "../components/Faq";
import PrimaryButton from "../components/PrimaryButton";
import SeconadaryBtn from "../components/SeconadaryBtn";
import OurTeam from "../components/OurTeam";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import promoVideo from "../assets/video/promo.mp4";
import HeroBg from "../assets/images/hero-bg.png"; // <-- add this

const reviews = [
  {
    text: "I live in Canada, but I feel like I’m right there with my mother in Yaoundé. VeriMED keeps me updated with every visit and her vitals in real time.",
    name: "James Rodrigo",
    role: "Customer",
  },
  {
    text: "The doctors are very professional and the support team is always available when I need them. Truly world-class service!",
    name: "Sophia Turner",
    role: "Patient",
  },
  {
    text: "Thanks to VeriMED, I can now track my father’s health easily and with peace of mind, even while living abroad.",
    name: "Michael Lee",
    role: "Customer",
  },
];
const teamMembers = [
  {
    name: "Stella Nsong",
    title: "Chief Caregiving Officer & Global Care Navigator",
    description:
      "Stella Nsong is an award-winning nurse entrepreneur, best selling author, elder care strategist, and global health futurist featured on CNN, CNBC, and FOX News. She is popularly known as The Elder Care Cliff Expert. She is redefining how the world approaches aging, wellness, and cross-border family care. As Co-Founder of VeriMED, she pioneers a new model of home health and geriatric wellness—bridging care between families abroad and their loved ones in Cameroon. Through VeriMED, Stella champions a seamless model of medical and wellness support for aging parents in Cameroon.",
    image: Team2,
    social: {
      facebook: FB,
      twitter: Twitter,
      instagram: Insta,
      youtube: YouTube,
    },
  },
  {
    name: "Dr. Stanley-Ivo Foy",
    title: "Co-Founder & Chief Medical Officer",
    description:
      "Dr. Stanley-Ivo Foy is one of Cameroon’s most gifted medical minds — a physician whose academic brilliance and clinical mastery have set him apart since his earliest training. Driven by relentless curiosity, daily study, and a deep commitment to clinical excellence. He has performed complex surgeries in Kumba that many believed were impossible to accomplish locally, let alone in Cameroon, expanding what quality care can look like in underserved environments. Known for his compassion, responsiveness, and calm clinical confidence, Dr. Foy blends rare intelligence with a heart for service. As Co-Founder of VeriMED, he partners with Stella Nsong to transform healthcare experiences for families in Cameroon. Their shared journeys — marked by the loss of loved ones to preventable medical failures — fuel their mission to deliver safe, modern, dignified, and dependable care that families can trust. Dr. Foy stands at the forefront of a new era in community-based and concierge-style medical service in Cameroon, shaping health outcomes with skill, innovation, and unwavering dedication",
    image: Team1,
    social: {
      facebook: FB,
      twitter: Twitter,
      instagram: Insta,
      youtube: YouTube,
    },
  },
];

const servicesCards = [
  {
    icon: icon1,
    title: "Physician Initial Consultation",
    desc: "Comprehensive intake visit (in-person or virtual) for new clients.",
  },
  {
    icon: icon2,
    title: "Physician In-Home Visit",
    desc: "Personalized home visit by a licensed physician.",
  },
  {
    icon: icon3,
    title: "Physician Virtual Visit",
    desc: "Video consultation with a licensed physician.",
  },
  {
    icon: icon4,
    title: "Skilled Nurse Wellness Check",
    desc: "Routine visit by nurse for vitals, medication adherence, and client well-being.",
  },
  {
    icon: icon5,
    title: "Skilled Nursing Rehydration",
    desc: "At-home IV fluid administration.",
  },
  {
    icon: icon6,
    title: "Skilled Nursing Infusion Therapy",
    desc: "Administration of prescribed IV medication.",
  },
  {
    icon: icon7,
    title: "Care Management & Navigation",
    desc: "Ongoing care coordination, appointment setting, and family updates.",
  },
];

const testimonials = [
  {
    title: "The Doctor Cameroon Needs, The One We All Deserve",
    text: "To our family, friends, and the wider community — Dr. Foy represents what every healthcare provider should be: compassionate, capable, and courageous. He has redefined what medical care in Cameroon can look like. He is a blessing to my family, a comfort to my mother and my older sister who lives in Kumba, and a source of pride to every Cameroonian at home and abroad. Thank you Dr. Foy, you ROCK!",
    author: "The Lamplighter USA",
    images: [client1, client2, client3, client4],
  },
  {
    title: "A Doctor Who Gave My Grand Mother Back to Us",
    text: "If not for Dr. Foy, I’m certain my grandmother would not be alive today. He has literally pulled her out of death’s grip more than once — drawing her blood himself, setting up IV lines, and administering emergency treatments when others would have no clue what to do. His dedication gave my grandmother her health back and gave my cousins and me, who live abroad, peace of mind that is priceless.",
    author: "Elie E. SA",
    images: [client2, client3, client4, client1],
  },
  {
    title: "When Others Said It Couldn’t Be Done",
    text: "My cousin had a life-threatening condition that most doctors said could not be operated on in Kumba. But Dr. Foy refused to accept that. He assembled a skilled surgical team, worked tirelessly through her surgical needs, and after weeks of hospitalization, my cousin is alive, strong, and thriving. What others called impossible, he made possible. Hats off Dr. Foy.",
    author: "Ray N USA",
    images: [client3, client4, client1, client2],
  },
  {
    title: "Healing the Mind Before Healing the Body",
    text: "When fear almost cost my cousin her life, it was Dr. Foy who stepped in. A pastor had told her that if she went for surgery, she would die. Dr. Foy took the time to educate her, calm her fears, and restore her confidence. She went through with the surgery — and today she is living testimony that faith and medicine can walk hand in hand when guided by wisdom and compassion.",
    author: "Tracy N, Canada",
    images: [client4, client1, client2, client3],
  },
  {
    title: "Excellence with a Human Touch",
    text: "Everyone who meets Dr. Foy says the same thing — he is kind, brilliant, gentle, and remarkably skilled. He listens, he explains, and he treats every patient as if they were family. His humility and humanity stand out in a world where so many have forgotten what true care feels like.",
    author: "Emilia N, Kumba, Cameroon",
    images: [client1, client2, client3, client4],
  },
  {
    title: "A Lifeline for Families in the Diaspora",
    text: "For those of us living abroad, knowing that our loved ones back home are under Dr. Foy’s care brings peace that cannot be bought. He bridges the distance between us and our families with professionalism, constant communication, and genuine care. He doesn’t just treat patients — he restores families’ hope across oceans.",
    author: "Armon S, Montreal Canada",
    images: [client1, client3, client4, client2],
  },
  {
    title: "Beyond Medicine — A Calling Fulfilled",
    text: "Dr. Foy’s work is more than a profession; it’s a calling. Whether it’s 2 a.m. emergencies, running tests himself, or personally checking on patients at home, his commitment is unmatched. In a healthcare system that often struggles, he shines as a symbol of integrity, excellence, and selfless service.",
    author: "Stella N, USA",
    images: [client2, client3, client4, client1],
  },
  {
    title: "Trust and Peace of Mind",
    text: "I had been looking for a doctor I could trust with my mom for a long time — professional, punctual, effective, and efficient — almost impossible till I met Dr. Foy. He has made life more relaxing for me with relevant and on-time information about my mom's health. He is someone you can trust!",
    author: "Mabrice E, Douala, Cameroon",
    images: [client2, client1, client3, client4],
  },
];

const Home = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const testimonial = testimonials[activeIndex];
  const membersPerPage = 2;
  const totalPages = Math.ceil(teamMembers.length / membersPerPage);

  const images = [client1, client2, client3, client4];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const handleDotClick = (index) => {
    setCurrentPage(index);
  };

  const [formData, setFormData] = useState({
    department: "",
    doctor: "",
    fullName: "",
    phone: "",
    date: "",
    time: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);

    setFormData({
      department: "",
      doctor: "",
      fullName: "",
      phone: "",
      date: "",
      time: "",
    });
  };

  return (
    <div style={{ overflowX: "hidden" }}>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="heroSection">
        {/* Background Image Layer */}
        <div
          className="heroBgLayer"
          style={{
            backgroundImage: `url(${HeroBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="heroContent">
          <p className="heroTopText">Medical And Health</p>

          <h1 className="heroTitle">
            Bridging Distance with Expert <br /> Medical Care
          </h1>

          <p className="heroSubtitle">
            Home Health and Geriatric Wellness for Cameroon’s Global Families.A
            physician-led, nurse-powered care program for diaspora professionals
            who demand exceptional, transparent, and reliable global standard
            medical care for their loved ones back home.
          </p>
          <div className="heroButtons">
            {/* <PrimaryButton
              label=" Enroll a Patient"
              onClick={() => {
                navigate("/membership");
              }}
            /> */}

            <SeconadaryBtn
              label="Explore Services"
              onClick={() => navigate("/services")}
            />
          </div>

          <div className="storeButtons">
            <img src={apple} alt="Download on App Store" className="storeBtn" />
            <img
              src={google}
              alt="Get it on Google Play"
              className="storeBtn"
            />
          </div>
        </div>

        <div className="heroImageWrapper">
          <img src={doctors} alt="VeriMed Doctors" className="heroImage" />
        </div>
      </section>

      <div className="servicesWrapper">
        <div className="servicesInner">
          {/* Heading + Subheading */}
          <div className="servicesHead">
            <h2 className="servicesTitle">
              Because Distance Shouldn’t Separate Love or Quality Care.
            </h2>
            <p className="servicesDesc">
              We bring expert home health, medical, and wellness services to
              aging parents in Cameroon—helping families abroad stay connected
              through compassion, technology, and trust.
            </p>
          </div>

          {/* Cards Section */}
          <div className="servicesGrid">
            {servicesCards.map((card, index) => (
              <div key={index} className="serviceCard">
                <img src={card.icon} alt="icon" className="serviceIcon" />
                <h3 className="serviceTitle">{card.title}</h3>
                <p className="serviceDesc">{card.desc}</p>
              </div>
            ))}
            {/* CTA Card */}
            <div className="serviceCTA">
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  marginBottom: "20px",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Book a visit today and bring world-class care home.
              </p>
              {/* <PrimaryButton
                label=" Enroll a Patient"
                onClick={() => {
                  navigate("/membership");
                }}
              /> */}
            </div>
          </div>
        </div>
      </div>

      {/* Video Section */}
      <div className="videoWrapper">
        <video
          src={promoVideo}
          controls
          autoPlay={false}
          className="videoBox"
        />
      </div>

      {/* appointment form */}
      <AppointmentForm />

      {/*stats*/}

      <Counter />

      {/*about*/}

      <div className="aboutWrapper">
        <div
          style={{
            flex: "0 0 45%",
            position: "relative",
          }}
        >
          <img src={about} alt="Doctor" className="aboutImage" />
        </div>

        <div
          style={{
            flex: "0 0 50%",
          }}
        >
          <h2 className="aboutTitle">About Us</h2>

          <p className="aboutText">
            VeriMED connects families abroad with trusted medical teams at home.
          </p>

          <p className="aboutText">
            At VeriMED, we make it possible for families living abroad to ensure
            their loved ones in Cameroon receive world-class, concierge-style
            healthcare at home.
          </p>

          <p className="aboutText">
            From routine check-ups to chronic condition management, we connect
            top-tier medical professionals with your elderly parent — all
            coordinated and monitored in real time through our easy-to-use app.
          </p>

          <p className="aboutText">
            <strong>Our mission is simple:</strong> to give you peace of mind
            and them the care they deserve.
          </p>

          {/* Button */}
          {/* <PrimaryButton
            label=" Enroll a Patient"
            onClick={() => {
              navigate("/membership");
            }}
          /> */}
        </div>
      </div>

      {/*how it works*/}
      <div className="howItWorksWrapper">
        <h2 className="howTitle">How It Works</h2>

        {/* Subtitle */}
        <p className="howSubtitle">
          From enrollment to real-time updates, every step is designed for
          clarity.
        </p>

        <div className="howSteps">
          <div className="howCard">
            <img src={Works1} alt="Enroll" className="howIcon" />
            <h3 className="howCardTitle">Enroll Your Parent</h3>
            <p className="howCardDesc">
              Sign up from anywhere in the world. Choose the care plan that fits
              your parent’s needs.
            </p>
          </div>

          <div className="howCard">
            <img src={Works2} alt="Care Team" className="howIcon" />
            <h3 className="howCardTitle">We Assign a Care Team</h3>
            <p className="howCardDesc">
              A dedicated doctor, nurse, and care coordinator are matched to
              your parent.
            </p>
          </div>

          <div className="howCard">
            <img src={Works3} alt="Virtual Care" className="howIcon" />
            <h3 className="howCardTitle">Receive In-Home & Virtual Care</h3>
            <p className="howCardDesc">
              From medical visits to medication tracking, our team delivers
              personalized care.
            </p>
          </div>

          <div className="howCard">
            <img src={Works4} alt="Monitor" className="howIcon" />
            <h3 className="howCardTitle">Monitor Everything from Your Phone</h3>
            <p className="howCardDesc">
              Get real-time updates, vital signs, visit notes, and alerts —
              wherever you are.
            </p>
          </div>
        </div>
      </div>

      {/*our team */}

      <OurTeam />

      {/* testmonial */}

      <div className="testimonialWrapper">
        <div className="testimonialContainer">
          {/* LEFT SIDE - Images */}
          <div className="testimonialImages">
            {/* Main (center) image */}
            <AnimatePresence mode="wait">
              <motion.img
                key={testimonial.images[0]}
                src={testimonial.images[0]}
                alt="main client"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.8 }}
                className="testimonialMainImg"
              />
            </AnimatePresence>

            {/* Static side images (dynamic positions kept inline) */}
            {testimonial.images.slice(1).map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`client-${i}`}
                className="testimonialSideImg"
                style={{
                  top: ["0%", "10%", "70%", "60%"][i % 4],
                  left: ["-5%", "70%", "10%", "80%"][i % 4],
                }}
              />
            ))}
          </div>

          {/* Decorative Background Circles */}
          <div className="testimonialBgCircleLarge"></div>
          <div className="testimonialBgCircleSmall"></div>

          {/* RIGHT SIDE - Text */}
          <div className="testimonialRight">
            {/* Quote */}
            <span className="testimonialQuote">❝</span>

            {/* Title */}
            <motion.h2
              key={testimonial.title}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.7 }}
              className="testimonialTitle"
            >
              {testimonial.title}
            </motion.h2>

            {/* Text */}
            <AnimatePresence mode="wait">
              <motion.p
                key={testimonial.text}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.7 }}
                className="testimonialText"
              >
                {testimonial.text}
              </motion.p>
            </AnimatePresence>

            {/* Author */}
            <motion.div
              key={testimonial.author}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <h3 className="testimonialAuthor">{testimonial.author}</h3>
            </motion.div>

            {/* Dots */}
            <div className="testimonialDots">
              {testimonials.map((_, i) => (
                <span
                  key={i}
                  onClick={() => setActiveIndex(i)}
                  className={`testimonialDot ${
                    activeIndex === i ? "active" : ""
                  }`}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Banner */}
      <Banner />

      {/* FAQ */}
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;
